<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="title" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'title'
        label= '消息标题'
        width= '300'>
      </el-table-column>
      <el-table-column
        prop= 'content'
        label= '消息'>
      </el-table-column>
      <el-table-column
        prop= 'fromUserName'
        label= '发送方'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'isRead'
        label= '是否已读'
        width= '100'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.isRead===1">已读</el-button>
          <el-button type='danger' size='small' v-if="scope.row.isRead===0">未读</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'addTime'
        label= '发送时间'
        width= '200'>
        <template slot-scope='scope'>
          {{ formatDate(scope.row.addTime) }}
        </template>
      </el-table-column>
      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '140'>
        <template slot-scope='scope'>
          <el-button @click='digDetail(scope.row)' type='text' size='small' style="color: #209323">查看详情</el-button>
          <el-button @click='readMsg(scope.row)' type='text' size='small' style="color: #2093f56c6c23" v-if="scope.row.isRead==0">标记已读</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" :modal="false">
            <el-form :model="form">
        <el-form-item label="标题" :label-width="formLabelWidth">
          <el-input v-model="form.title" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="发送方" :label-width="formLabelWidth">
          <el-input v-model="form.fromUserName" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="消息" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="12" v-model="form.content" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import { formatDate } from '../../../util/date'
export default {
  data () {
    return {
      tableData: [],
      title: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        title: null,
        content: null,
        fromUserId: null,
        fromUserName: null,
        receiveUserId: null,
        receiveUserName: null,
        isRead: null
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0
    }
  },
  created () {
    this.query()
  },
  methods: {
    query () {
      let that = this
      requestService.get(`/message/receive/listPage?current=${that.current}&pageSize=${that.pageSize}&title=${that.title}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digDetail (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    readMsg (row = {}) {
      requestService.post('/message/readMsg', {id: row.id
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        row.isRead = 1
      })
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/message/Index.vue